// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.name[data-v-75ad4a4a] {
	font-weight: bold;
	color: var(--color-primary-element);
	font-size: var(--default-font-size);
	line-height: var(--default-clickable-area);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	opacity: .7;
	box-shadow: none !important;
	flex-shrink: 0;
	padding: 0 calc(var(--default-grid-baseline, 4px) * 2) 0 calc(var(--default-grid-baseline, 4px) * 3);
}
`, "",{"version":3,"sources":["webpack://./src/components/NotesCaption.vue"],"names":[],"mappings":";AAsCA;CACA,iBAAA;CACA,mCAAA;CACA,mCAAA;CACA,0CAAA;CACA,mBAAA;CACA,gBAAA;CACA,uBAAA;CACA,WAAA;CACA,2BAAA;CACA,cAAA;CACA,oGAAA;AACA","sourcesContent":["<template>\n\t<h3 class=\"name\">\n\t\t{{ name }}\n\t</h3>\n</template>\n\n<script>\nexport default {\n\tname: 'NotesCaption',\n\n\tcomponents: {\n\t},\n\n\tprops: {\n\t\tname: {\n\t\t\ttype: String,\n\t\t\trequired: true,\n\t\t},\n\t},\n}\n</script>\n\n<style scoped>\n\t.name {\n\t\tfont-weight: bold;\n\t\tcolor: var(--color-primary-element);\n\t\tfont-size: var(--default-font-size);\n\t\tline-height: var(--default-clickable-area);\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\topacity: .7;\n\t\tbox-shadow: none !important;\n\t\tflex-shrink: 0;\n\t\tpadding: 0 calc(var(--default-grid-baseline, 4px) * 2) 0 calc(var(--default-grid-baseline, 4px) * 3);\n\t}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
